




































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import NewAddRowVue from "../components/DayAccountList/NewAddRow.vue";
import ImportDayAccountVue from "../components/DayAccountList/ImportDayAccount.vue";
import SzTypes from "@/data/SzTypes";
import ThDropdownVue from "../components/ThDropdown.vue";
import BankImportVue from "../components/DayAccountList/BankImport.vue";
import version from "@/version";
import InvoiceScanVue from "@/components/Invoice/InvoiceScan.vue";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "newAdd-row": NewAddRowVue,
        "import-day": ImportDayAccountVue,
        "th-dropdown": ThDropdownVue,
        "bank-import": BankImportVue,
        "invoice-scan": InvoiceScanVue
    }
})
export default class Journal extends Vue {
    delButton: string = "批量删除";
    isShowCheck: boolean = false;
    endMonth: string = "";
    mounted() {
        this.getBanks()
        this.getAccounters()
    }
    //分页
    currentPage: number = 1;
    pageSize: number = 20;
    totalElements: number = 0;
    totalPages: number = 0
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.fetchData();
    }
    //选中每页条数
    changeSize(size: number) {
        this.pageSize = size;
        this.fetchData();
    }
    confirmFilter() {
        console.log(this.startDate)
        this.fetchData()
        this.filterVisible = false
		// this.isRetract = true;
		// this.balContentNowYear = this.isBNLJ;
		// this.startLevel = this.minLevel;
		// this.endLevel = this.maxLevel;
		// this.fetchData();
		// this.filterVisible = false;
	}
     startDate = ""
     endDate = ""
     minAmount = ""
     maxAmount = ""
     summary = ""
     oppositeAccountName = ""
     incomePayType = ""
     filterVisible = false
    resetFilter() {
        this.bankStatus = {
            id: "",
            text: "全部"
        }
        this.incomePayType = ""
        this.startDate = ""
        this.endDate = ""
        this.minAmount = ""
        this.maxAmount = ""
        this.summary = ""
        this.oppositeAccountName = ""

		// this.startSubject = null;
		// this.endSubject = null;
		// this.minLevel = 1;
		// this.maxLevel = 5;
		// this.isBNLJ = false;
		// this.isShowDim = true;
		// this.isHideZeroEnd = false;
		// this.isHideZeroFs = false;
	}

    budget = SzTypes.list;
    get options() {
        return {
            disabledDate: (time: Date) => {
                let cur: string = this.endMonth.substring(0, 4) + "-" + this.endMonth.substring(4),
                    start: Date = new Date(cur + "-" + "01"),
                    end: Date = this.getCurrentMonthLast(new Date(cur));
                return time.getTime() > end.getTime();
            }
        }
    };
    getCurrentMonthLast(date: Date) {//获取下拉时间选择的范围
        let currentMonth: number = date.getMonth();
        let nextMonth: number = ++currentMonth;
        let nextMonthFirstDay: any = new Date(date.getFullYear(), nextMonth, 1);
        let oneDay: number = 1000 * 60 * 60 * 24;
        return new Date(nextMonthFirstDay - oneDay);
    }
    // 获取焦点 行
    selectnner(e: any) { e.target.select(); }
    // 失去焦点  下拉选择
    curRow: Journal.Journal | null = null
    blurRow(row: Journal.Journal, e?: any) {
        this.curRow = row;
        let accounter = row.oppositeAccountName;
        if (e && e.target) {
            if (e.target.placeholder === accounter && e.target.value === "") {
                row.oppositeAccountName = e.target.placeholder;
            } else {
                row.oppositeAccountName = e.target.value;
            }
        }
    }
    // 获取表格数据
    initBalance: string = ""
    endBalance: string = ""
    totalIncome: string = ""
    totalPay: string = ""
    journalList: Journal.Journal[] = [];
    listCopy: Journal.Journal[] = [];
    canPrint = false;
    fetchData() {
        let searchKey = this.bankStatus.text
        if (searchKey === "全部") searchKey = ""
        Vue.axios
            .post(
                `journals?period=${this.period}&page=${this.currentPage - 1}&size=${this.pageSize}&accountBookId=${this.$store.state.accountBook.id}&journalType=${0}&isSortById=${this.isSortById ? 1 : 0}&searchKey=${searchKey}&incomePayType=${this.incomePayType}&maxAmount=${this.maxAmount}&minAmount=${this.minAmount}&startDate=${(this.startDate != ""&&this.startDate!=null )?this.$utils.simpleDateFormat(new Date(this.startDate), "d"):""}&endDate=${(this.endDate !="" && this.endDate != null)?this.$utils.simpleDateFormat(new Date(this.endDate), "d"):""}&summary=${this.summary}&oppositeAccountName=${this.oppositeAccountName}`
            )
            .then(res => {
                res.data.journalList.content.forEach((e: any) => {
                    e.journalDate = this.transDate(e.journalDate);
                    e.check = false;
                    for (let i = 0; i < this.budget.length; i++) {
                        if (+e.incomePayType === this.budget[i].id) {
                            e.incomePayType = this.budget[i];
                            break;
                        }
                    }
                });
                this.canPrint = res.data.isReceipt;
                this.totalElements = res.data.journalList.totalElements
                this.totalPages = res.data.journalList.totalPages
                this.journalList = res.data.journalList.content; this.initBalance = res.data.initBalance; this.endBalance = res.data.endBalance; this.totalIncome = res.data.totalIncome; this.totalPay = res.data.totalPay; this.listCopy = [];
                for (let i = 0; i < this.journalList.length; i++) {
                    this.listCopy.push(JSON.parse(JSON.stringify(this.journalList[i])))
                }
            });
    }
    transDate(date: string) {
        if (typeof (date) === "string") {
            let year = date.substr(0, 4),
                month = date.substr(4, 2),
                day = date.substr(6);
            return new Date(`${year}-${month}-${day}`);
        } else { return this.$utils.simpleDateFormat(date, "d", true); }
    }
    // 对方户名
    accounters: any = {}
    getAccounters(type?: Journal.PayType) {
        if (!type) {
            this.budget.forEach((v: any) => {
                Vue.axios
                    .post(`journals/oppositeaccountnames?accountBookId=${this.$store.state.accountBook.id}&incomePayType=${v.id}`)
                    .then(res => { this.accounters["a" + v.id] = res.data });
            });
        } else {
            Vue.axios
                .post(`journals/oppositeaccountnames?accountBookId=${this.$store.state.accountBook.id}&incomePayType=${type.id}`)
                .then(res => { this.accounters["a" + type.id] = res.data });
        }
    }
    //改变时间
    period: string = ""; // 日期
    changeDate(date: string, endMonth: string) {
        this.period = date;
        this.endMonth = endMonth;
        this.fetchData();
    }
    // 判断是否显示的
    get isClose() {
        let close = this.$store.state.accountBook.closePeriod;
        if (close != null && this.period != "") {
            let closeDate = new Date(close.substr(0, 4) + "-" + close.substr(4)),
                curPeriod = new Date(this.period.substr(0, 4) + "-" + this.period.substr(4));
            return curPeriod <= closeDate
        } else return false
    }
    // 选择录入顺序
    isSortById: boolean = false
    sortByIdChange(val: boolean) {
        this.isSortById = val
        this.fetchData()
    }
    // 导入日记账
    scanVisible = false;
    showImport = false;
    importCommand(cmd: string) {
        if (cmd === "模板导入") {
            this.showImport = true
        } else {
            this.scanVisible = true;
        }
    }
    // showImport: boolean = false
    // importDayAccount() {
    //     this.showImport = true
    // }
    closeImport(val: boolean) {
        if (val) this.fetchData()
        this.showImport = false
    }
    //全部选中
    changeAll(val: boolean) {
        this.journalList.forEach(v => {
            if (this.isPrint) {
                if (val && v.receiptUrl !== null) v.check = true;
                else v.check = false;
            } else {
                v.check = val;
            }
        })
    }

    // 打印回单按钮显示
    printButton = "打印回单";
    isPrint = false;
    // 批量删除/打印
    showCheckBox(isReceipt?: boolean) {
        this.isPrint = isReceipt ? isReceipt : false;
        if (!isReceipt) {
            if (!this.isShowCheck) {
                this.delButton = "取消";
                this.isShowCheck = true;
            } else {
                if (this.printButton !== "打印回单") {
                    this.printButton = "打印回单";
                    this.isShowCheck = false;
                    this.clearCheck();
                }
                if (this.delButton === "删除") {
                    this.deleteLot();
                } else {
                    this.delButton = "批量删除";
                    this.isShowCheck = false;
                    this.clearCheck();
                }
            }
        } else {
            if (!this.isShowCheck) {
                this.printButton = "取消";
                this.isShowCheck = true;
            } else {
                if (this.delButton !== "批量删除") {
                    this.delButton = "批量删除";
                    this.isShowCheck = false;
                    this.clearCheck();
                }
                if (this.printButton === "打印") {
                    this.printLot();
                } else {
                    this.printButton = "打印回单";
                    this.isShowCheck = false;
                    this.clearCheck();
                }
            }
        }
    }

    async printLot() {
        let val: string[] = [];
        this.journalList.forEach((v: Journal.Journal) => {
            console.log(v)
            if (v.check) {
                val.push(v.id);
            }
        });
        const max = 100;
        if (val.length > max) {
            this.$alert(`亲,请选择小于 ${max} 条回单已打印`);
            return;
        }
        const url = `${Vue.axios.defaults.baseURL}export/pdf/receipt/print?id=${val.join(",")}&token=${this.$store.state.account.token}&version=${version}`;
        console.log(url);
        this.$utils.sendToElectron("download-pdf", url);
    }
    checkAll: boolean = false  //是否全选
    @Watch("journalList", { deep: true })
    listChange(val: any) {
        let all = true,
            hasSelect = false;
        val.forEach((v: Journal.Journal) => {
            if (!v.check) all = false;
            else hasSelect = true;
        });
        this.checkAll = all;
        if (hasSelect) {
            if (this.delButton === "取消") this.delButton = "删除";
            if (this.printButton === "取消") this.printButton = "打印";
        } else {
            if (this.delButton === "删除") this.delButton = "取消";
            if (this.printButton === "打印") this.printButton = "取消";
        }
    }
    clearCheck() {
        this.journalList.forEach((v: Journal.Journal) => {
            if (v.check) v.check = false;
        })
    }
    // 删除日记账
    deleteLot() {
        let val: string[] = [];
        this.journalList.forEach((v: Journal.Journal) => {
            if (v.check) val.push(v.id);
        })
        let b = { id: val.join(",") }
        this.$confirm(`亲，您选中了 ${val.length} 条日记账，是否确认删除？`, "温馨提示").then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .delete(`journals`, { data: b, })
                    .then(res => { this.delButton = "批量删除"; this.isShowCheck = false; this.fetchData() });
            }
        })
    }
    // 删除行
    deleteRow(ids: number) {
        let val = { id: ids }
        this.$confirm("亲，确定删除吗？", "温馨提示").then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .delete(`journals`, { data: val, headers: { "Content-Type": "application/json;charset=UTF-8" } })
                    .then(res => { this.fetchData() });
            }
        })
    }
    // 开户行改为可自定义新增的下拉框
    banks: { key: string; value: boolean; }[] = [];
    bankList: any[] = [
        {
            text: "全部",
            id: 0
        }
    ];
    getBanks() {
        Vue.axios
            .post(`journals/openingbanks?accountBookId=${this.$store.state.accountBook.id}`)
            .then(res => {
                const list: { key: string; value: boolean; }[] = [];
                Object.keys(res.data.openingBanks).forEach(v => {
                    list.push({
                        key: v,
                        value: res.data[v]
                    });
                });
                this.banks = list;
                for (let i = 0; i < list.length; i++) {
                    this.bankList.push({ text: "", id: null });
                    this.bankList[i + 1].text = list[i].key;
                    this.bankList[i + 1].id = i + 1;
                }
            });
    }
    getStatus(type: number, code: number) {
        for (let i = 0; i < this.bankList.length; i++) {
            if (this.bankList[i].id === code) return this.bankList[i];
        }
    }
    bankStatus: DataTable.DropItem = this.bankList[0];
    // 监听修改 canEditIndex
    @Watch("canEditIndex")
    canEditIndexChanged(val: number, before: number) {
        if (before != -1) {
            this.leaveRow(2, this.curRow, before);
        }
    }
    // 新增修改  行数据
    leaveRow(type: number, row?: any, before?: any) {
        if (type === 2) {
            if (row) {
                if (row.pay === "" && row.income === "") {
                    this.confirmBox(type, "金额", before);
                } else if (row.pay != "" || row.income != "") {
                    if (this.journalList[before].summary != this.listCopy[before].summary || this.journalList[before].pay != this.listCopy[before].pay || this.journalList[before].income != this.listCopy[before].income || this.journalList[before].journalDate.toString() != new Date(this.listCopy[before].journalDate).toString() || JSON.stringify(this.journalList[before].incomePayType) != JSON.stringify(this.listCopy[before].incomePayType) || this.journalList[before].oppositeAccountName != this.listCopy[before].oppositeAccountName || this.journalList[before].openingBank != this.listCopy[before].openingBank) {
                        this.editRow(row, true);
                        this.getAccounters(row.incomePayType);
                    }
                }
            }
        } else {
            let addTr = <NewAddRowVue>this.$refs.addTr;
            if (addTr.newOut === "" && addTr.newIncome === "" && (addTr.newZy != "" || addTr.newBank != "" || addTr.newAccount != "")) {
                this.confirmBox(type, "金额");
            } else if (addTr.newIncome != "" || addTr.newOut != "") {
                let day = this.$utils.simpleDateFormat(<Date>addTr.newDate, "d");
                Vue.axios
                    .post(`journals`, {
                        accountBookId: this.$store.state.accountBook.id,
                        journalDate: day,
                        summary: addTr.newZy,
                        income: addTr.newIncome,
                        pay: addTr.newOut,
                        journalType: 0,
                        incomePayType: addTr.newSz.id,
                        oppositeAccountName: addTr.newAccount,
                        openingBank: addTr.newBank,
                        period: this.period
                    })
                    .then(res => {
                        if (addTr.newSz) this.getAccounters(addTr.newSz);
                        addTr.clearData();
                        this.fetchData();
                    });
            }
        }
    }
    confirmBox(type: number, text: string, before?: any) {
        let index = type === 2 ? before : -1;
        this.$confirm(`没有${text}，无法保存，是否放弃本行？`, "温馨提示", {
            callback: (action: any) => {
                if (action === "cancel") {
                    this.canEditIndex = index;
                    this.$nextTick(() => {
                        if (index > -1) (<any>document.querySelectorAll(".list-row")[before].querySelector(".summaryTd input")).focus();
                        else (<any>document.querySelector(".newZy input")).focus();
                    })
                } else {
                    if (type != 2) (<any>this.$refs.addTr).clearData();
                    else this.fetchData();
                }
            }
        })
    }
    canEditIndex: number = -1
    editThisRow(index: number, e: any) {
        if (!this.isClose) {
            this.canEditIndex = index;
            this.$nextTick(() => {
                for (let i = 0; i < e.path.length; i++) {
                    if (e.path[i].nodeName === "TD") {
                        e.path[i].querySelector("input").focus();
                        break;
                    }
                }
            })
        }
    }
    // 选择收支类型
    changeSzGetAccount(payType: any, row: Journal.Journal, i: number) {
        // row.oppositeAccountName = "";
        let sel = (<any>this.$refs["accountSelect" + i]);
        sel[0].focus();
    }
    // 修改日记账 行的时间期间
    changeData(row: Journal.Journal, index: number) {
        // if (JSON.parse(JSON.stringify(row)).journalDate != this.listCopy[index].journalDate)
        //     // this.editRow(row);
    }
    editRow(row: Journal.Journal, isEdit?: boolean) {
        let rowCopy = JSON.parse(JSON.stringify(row));
        rowCopy.incomePayType = rowCopy.incomePayType.id;
        rowCopy.journalDate = this.$utils.simpleDateFormat(new Date(rowCopy.journalDate), "d");
        Vue.axios.put(`journals`, rowCopy).then(res => { this.fetchData(); this.canEditIndex = -1 });
    }

    toNext(e: KeyboardEvent, isNum: boolean, row?: Journal.Journal, index?: number, type?: number) {
        this.$utils.arrowPress(e, false);
        if (row && e.keyCode != 13 && e.keyCode != 9) {
            if (type === 0) {
                row.pay = "";
            } else {
                row.income = "";
            }
        } else if (row && type === 1) this.canEditIndex = -1;
    }

    changeRow(row: Journal.Journal) {
        this.curRow = row;
        this.canEditIndex = -1;
    }

    bankVisible = false;
    closeBank() {
        this.bankVisible = false;
        this.fetchData();
    }
}
